import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './langs'
Vue.use(VueI18n);

const i18nLocal = localStorage.getItem("i18n");
const i18n = new VueI18n({
  locale: i18nLocal ? i18nLocal : i18nLocale, //初始未选择默认 zh 中文
  messages,
  silentTranslationWarn: true
});

export default i18n